export default __webpack_public_path__ + "static/media/CBE.4f8d77d5.png";